import { render, staticRenderFns } from "./NacexAddressBlock.vue?vue&type=template&id=ff754c82&scoped=true"
import script from "./NacexAddressBlock.vue?vue&type=script&lang=js"
export * from "./NacexAddressBlock.vue?vue&type=script&lang=js"
import style0 from "./NacexAddressBlock.vue?vue&type=style&index=0&id=ff754c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff754c82",
  null
  
)

export default component.exports